import gql from 'graphql-tag';

export const assemblerQueryForAiProgramBuilderContext = gql`
  query AssemblerAiProgramBuilderContext($orgId: String!) {
    EnterpriseUserRostersV1Resource {
      byOrganization(id: $orgId) {
        elements {
          id
          contract {
            id
          }
          programInvitations(limit: 1) {
            paging {
              total
            }
          }
        }
      }
    }
  }
`;
